import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { TrainSyncData } from '../../models/train-sync-data';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-monitored-train-synchronization',
  template: require('./monitored-train-synchronization.component.html'),
  styles: [require('./monitored-train-synchronization.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonitoredTrainSynchronizationComponent implements OnInit {

  @Input() syncData: TrainSyncData[];
  columns: any[] = [ 
    {
      header: this.translate.instant('I18N_MONITORING.ENTITY_NAME'),
      field: 'entityName',
      type:'text'
    },
    {
      header: this.translate.instant('I18N_MONITORING.BYTES_RECEIVED'),
      field: 'bytesReceived'
    },
    {
      header: this.translate.instant('I18N_MONITORING.LAST_SYNC_DATE'),
      field: 'date'
    },
    {
      header: this.translate.instant('I18N_MONITORING.LAST_SUCCESS'),
      field: 'lastSuccess'
    }
  ]
  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {

  }

}
